import { GET_INVENTORY_REPORT, GET_INVENTORY_REPORT_SUCCESS, GET_INVENTORY_REPORT_FAILED } from './constants';

export const getInventoryReportActions = (filters) => ({
    type: GET_INVENTORY_REPORT,
    payload: filters
});

export const getInventoryReportSuccessActions = (data) => ({
    type: GET_INVENTORY_REPORT_SUCCESS,
    payload: data
});

export const getInventoryReportFailedActions = (error) => ({
    type: GET_INVENTORY_REPORT_FAILED,
    payload: error
});
